<template>
  <div :class='headerClass' @click="$emit('click')">
    <slot name='default' />
  </div>
</template>

<script>
export default {
  name: 'HeaderElementButton',
  props: {
    blue: Boolean,
    red: Boolean,
    green: Boolean,
    yellow: Boolean,
    gray: Boolean,
    disabled: Boolean,

    remove: Boolean
  },
  computed: {
    headerClass () {
      let result = 'header-element-button';
      if (this.blue) result += ' blue';
      else if (this.red) result += ' red';
      else if (this.yellow) result += ' yellow';
      else if (this.green) result += ' green';
      else if (this.gray) result += ' gray';
      else result += ' gray';

      if (this.remove) result += ' remove';
      if (this.disabled) result = 'header-element-button disabled';

      return result;
    }
  }
};
</script>

<style lang='scss' scoped>
  @import "../../utils/assets/stylesheets/variables.scss";

  .header-element-button {
    width: auto;
    width: fit-content;
    display: block;
    padding: 13px 18px;

    background-color: $gray-lighten-2;
    color: $primary;
    font-weight: 600;

    border-radius: $border-radius;
    cursor: pointer;

    transition: $base-transition;

    .v-icon {
      color: $primary;
      font-size: 1.2em;
      padding-bottom: 0px;
      transition: $base-transition;
    }

    &.gray {
      background-color: $gray-lighten-2;
      color: $primary;

      .v-icon {
        color: $primary;
      }

      &:hover {
        background-color: $primary;
        color: white;
        .v-icon { color: white; }
      }
    }

    &.disabled {
      background-color: $gray-lighten-2 !important;
      color: $primary-lighten-2 !important;

      .v-icon {
        color: $primary-lighten-2 !important;
      }

      &:hover {
        background-color: $gray-lighten-3 !important;
      }
    }

    &.yellow {
      background-color: $tertiary-lighten-3 !important;
      color: $tertiary-darken-1 !important;

      .v-icon {
        color: $tertiary-darken-1 !important;
      }

      &:hover {
        background-color: $tertiary-darken-1 !important;
        color: white;
        .v-icon { color: white; }
      }
    }

    &.blue {
      background-color: $secondary-lighten-4 !important;
      color: $secondary !important;
      .v-icon { color: $secondary; }

      &:hover {
        background-color: $secondary !important;
        color: white;
        .v-icon { color: white; }
      }
    }

    &.red {
      background-color: $error-lighten-2 !important;
      color: $error !important;

      .v-icon {
        color: $error;
      }
    }

    &.green {
      background-color: $positive-lighten-3 !important;
      color: $positive !important;
      .v-icon { color: $positive; }

      &:hover {
        background-color: $positive !important;
        color: white;
        .v-icon { color: white; }
      }
    }

    &.remove {
      &:hover {
        background-color: $error !important;
        color: white !important;
        .v-icon { color: white !important }
      }
    }
  }
</style>
